<template>
  <div>
    <div class="back_img"></div>
    <div class="back_img_1">
      <div class="hedertop">
        <img src="@/assets/logo.png" alt="">
      </div>
      <div class="formbox">
        <el-form
            label-position="top"
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            style="width:300px;padding-top: 150px"
            label-width="100px"
            class="myform"
        >
          <el-form-item prop="phone">
            <div class="inputBg flex bb align-center">
              <img src="../../assets/loginPhone.svg" alt="">
              <el-input
                  v-model.trim="ruleForm.UserName"
                  type="text"
                  clearable
                  placeholder="请输入"
                  size="medium"
                  @keydown.enter.native="submitForm('ruleForm')"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="pass">
            <div class="inputBg bb flex align-center">
              <img src="../../assets/loginPass.svg" alt="">
              <el-input
                  type="password"
                  show-password
                  v-model.trim="ruleForm.password"
                  placeholder="请输入"
                  maxlength="25"
                  @keydown.enter.native="submitForm('ruleForm')"
                  size="medium"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="checkCode">
            <div class="inputBg bb flex align-center">
              <img src="../../assets/loginformcode.svg">
              <el-input
                  v-model.trim="ruleForm.checkCode"
                  type="text"
                  placeholder="请输入验证码"
                  autocomplete="off"
                  @keydown.enter.native="submitForm('ruleForm')"
                  size="medium">
                <img :src="checkCodeImage" slot="suffix"
                     class="send-code" @click="sendVerifyCode" alt=""/>
              </el-input>
            </div>
          </el-form-item>
          <div class="flex align-center">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
          </div>
          <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              class="loginBtn"
              size="medium"></el-button>
        </el-form>
      </div>
    </div>
      <div class="bottom"><a href="https://beian.miit.gov.cn/#/" style="color: rgb(142, 142, 142);">ICP备案/许可证号: 蜀ICP备2021004855号-1</a></div>
  </div>
</template>

<script>
export default {
  data() {
    let validCode = (rule, value, callback) => {
      if (value != "") {
        if (!this.checkCode()) {
          callback(new Error("请输入正确的验证码"));
        }
        callback();
      }
    };
    return {
      ruleForm: {
        UserName: "",
        password: "",
        checkCode: ""
      },
      rules: {
        UserName: [{required: true, trigger: "blur", message: "请输入您的用户名"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
        checkCode: [
          {required: true, message: "请输入验证码", trigger: "blur"},
        ],
      },
      checkCodeImage: '',
      requestId: '',
      remainTimes: 0,
      checked: false,
    };
  },
  watch: {
    checked: function (val) {
      if (val) {
        window.utils.storage.setter("userInfo", this.ruleForm);
      } else {
        window.utils.storage.remove('userInfo')
      }
    }
  },
  mounted() {
    // 初始化图形验证码
    this.checkImageGet()
  },
  created() {
    let userInfo = window.utils.storage.getter('userInfo')
    if (userInfo) {
      this.checked = true
      this.ruleForm.UserName = userInfo.UserName
      this.ruleForm.password = userInfo.password
    }
  },
  methods: {
    GetOtherConfig() {// 全局参数list
      let data={
        ConfigType:0
      }
      this.axios
          .get("/api/ParamConfig/GetOtherConfig", {params: data}).then((res) => {
        window.utils.storage.setter("GetOtherConfig", res);
      })
    },
    checkImageGet() { // 获取图形验证码
      this.axios.get('api/Login/CheckImageGet').then((res) => {
        this.checkCodeImage = this.axios.defaults.baseURL + res.data.imageData
        this.requestId = res.data.requestId
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let data = {
          userName: this.ruleForm.UserName,
          password: this.ruleForm.password,
          requestId: this.requestId,
          checkCode: this.ruleForm.checkCode,
        }
        this.axios.post("api/Login", data).then((res) => {
          if (res.data.userType === 0) {
            let headerToken = res.data.token
            if (this.checked) {
              window.utils.storage.setter("userInfo", this.ruleForm);
            } else {
              window.utils.storage.remove('userInfo')
            }
            window.utils.storage.setter("userJson", res.data);
            window.utils.storage.setter("headerToken", headerToken);
            this.GetOtherConfig()
            this.$router.push("/home/workbench");
          } else {
            this.$message.error('该用户没有权限');
          }
        })
            .catch((err) => {
              this.checkImageGet()
            })
      });
    },
    //重新获取图片
    sendVerifyCode() {
      this.checkImageGet()
    },
  },
};
</script>

<style lang="scss">
.formbox {
  .el-input--medium .el-input__inner {
    background: none;
    height: 40px;
    color: #7be8fb;
    border: none;
  }

  input::-webkit-input-placeholder {
    color: #4ca7be;
  }

  .el-form-item--small .el-form-item__error {
    padding-left: 20px;
    padding-top: 5px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 23px;
  }

  .el-input__suffix {
    color: #4ca7be;
  }

  .el-checkbox__inner {
    background: none;
    border-radius: 2px;
    width: 17px;
    height: 17px;
    border: solid 1px #7be8fb
  }

  .el-checkbox__label {
    color: #4ca7be;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #7be8fb;
    border-color: #7be8fb;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #7be8fb;
  }

  .el-checkbox__inner::after {
    top: 2px;
    left: 6px;
  }

  .el-input .el-input__clear {
    color: #7be8fb;
  }

  .send-code {
    height: 33px;
    color: #bff2ff;
    cursor: pointer;
    background-image: linear-gradient(52deg,
        #86dee4 0%,
        #4eb9c4 100%);
    border: none;
  }

  input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
    -webkit-text-fill-color: #7be8fb !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    background-color: transparent;
    transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
  }
}
</style>
<style lang="scss" scoped>
.back_img {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: fixed;
  background: url("../../assets/loginbg.jpg");
  z-index: -1;
  background-size: 100% 100%;
  box-sizing: border-box;
}

.back_img_1 {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
}

.hedertop {
  width: 100%;
  height: 67px;

  img {
    padding-top: 22px;
    padding-left: 142px;
  }
}

.formbox {
  width: 445px;
  height: 628px;
  box-sizing: border-box;
  border-radius: 5px;
  padding-left: 54px;
  background: url("../../assets/loginformbg.png");
  position: absolute;
  top: calc(50% - 314px);
  right: 10%;
  animation: mymove 1.5s ease-in-out alternate;
  overflow: hidden;
  transition: 1.5s;

  .inputBg {
    background: url("../../assets/loginInputbg.png");
    width: 346px;
    height: 65px;
    background-size: 100% 100%;
    padding: 10px;
  }
}

.pwdBox {
  display: flex;
  justify-content: space-between;
}

.loginBtn {
  width: 346px;
  height: 66px;
  margin-top: 33px;
  box-sizing: border-box;
  border: none;
  background: url("../../assets/loginbtn.png");
  background-size: 100% 100%;
}

.myform {
  margin-top: 35px;
}

@keyframes mymove {
  0% {
    width: 0px;
    right: 0;
    height: 5px;
  }
  50% {
    width: 420px;
  }
  80% {
    width: 420px;
    right: 12%;
  }
  100% {
    height: 628px;
    right: 10%;
  }
}
.bottom{
  width: 100%;
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    color: #c1c1c1;
    position:fixed;
    bottom: 20px;
    text-align: center;
    z-index: 999;

}
</style>
